<ngx-gallery-arrows
  (onPrevClick)="showPrev()"
  (onNextClick)="showNext()"
  [prevDisabled]="!canShowPrev()"
  [nextDisabled]="!canShowNext()"
  [arrowPrevIcon]="arrowPrevIcon"
  [arrowNextIcon]="arrowNextIcon"
></ngx-gallery-arrows>
<div class="ngx-gallery-preview-top">
  <div class="ngx-gallery-preview-icons">
    <ngx-gallery-action
      *ngFor="let action of actions"
      [icon]="action.icon"
      [disabled]="action.disabled"
      [titleText]="action.titleText"
      (onClick)="action.onClick($event)"
    ></ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="showDownloadOnAction && extension != 'pdf'"
      icon="material-icons download"
      (onClick)="handleDownload($event, i)"
    ></ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="zoom && extension != 'pdf'"
      [icon]="zoomOutIcon"
      [disabled]="!canZoomOut()"
      (onClick)="zoomOut()"
    ></ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="zoom && extension != 'pdf'"
      [icon]="zoomInIcon"
      [disabled]="!canZoomIn()"
      (onClick)="zoomIn()"
    ></ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="rotate && extension != 'pdf'"
      [icon]="rotateLeftIcon"
      (onClick)="rotateLeft()"
    >
    </ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="rotate && extension != 'pdf'"
      [icon]="rotateRightIcon"
      (onClick)="rotateRight()"
    >
    </ngx-gallery-action>
    <ngx-gallery-action
      *ngIf="fullscreen && extension != 'pdf'"
      [icon]="'ngx-gallery-fullscreen ' + fullscreenIcon"
      (onClick)="manageFullscreen()"
    ></ngx-gallery-action>
    <ngx-gallery-action
      [icon]="'ngx-gallery-close ' + closeIcon"
      (onClick)="close()"
    ></ngx-gallery-action>
  </div>
</div>
<div class="ngx-spinner-wrapper ngx-gallery-center" [class.ngx-gallery-active]="showSpinner">
  <i class="ngx-gallery-icon ngx-gallery-spinner {{ spinnerIcon }}" aria-hidden="true"></i>
</div>
<div
  class="ngx-gallery-preview-wrapper"
  [ngSwitch]="extension"
  (click)="closeOnClick && close()"
  (mouseup)="mouseUpHandler($event)"
  (mousemove)="mouseMoveHandler($event)"
  (touchend)="mouseUpHandler($event)"
  (touchmove)="mouseMoveHandler($event)"
>
  <div *ngSwitchCase="'pdf'">
    <div class="pdf-viewer-container flex justify-content-center">
      <iframe
        [src]="src | safeResourceUrl"
        [style.transform]="'scale(' + zoomValue + ') rotate(' + rotateValue + 'deg)'"
        height="100%"
        width="90%"
        id="pdfIFrame"
      ></iframe>
      <!--
      <pdf-viewer
        #pdfViewer
        [src]="src ? src : '#'"
        [show-all]="true"
        [zoom]="zoomValue"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="false"
        style="display: block"
      ></pdf-viewer>-->
    </div>
  </div>
  <div *ngSwitchDefault class="ngx-gallery-preview-img-wrapper">
    <img
      #previewImage
      class="ngx-gallery-preview-img ngx-gallery-center"
      [src]="src ? src : '#'"
      (click)="$event.stopPropagation()"
      (mouseenter)="imageMouseEnter()"
      (mouseleave)="imageMouseLeave()"
      (mousedown)="mouseDownHandler($event)"
      (touchstart)="mouseDownHandler($event)"
      [class.ngx-gallery-active]="!loading"
      [class.ngx-gallery-grab]="canDragOnZoom()"
      [style.transform]="'scale(' + zoomValue + ') rotate(' + rotateValue + 'deg)'"
      [style.left]="positionLeft + 'px'"
      [style.top]="positionTop + 'px'"
    />
  </div>
  <div class="ngx-gallery-preview-text" *ngIf="showDescription && descriptionData">
    <ngx-gallery-description [data]="descriptionData"></ngx-gallery-description>
  </div>
</div>
